<h3 mat-dialog-title>Application History</h3>
<mat-dialog-content>
    <div class="application-history-content" >
        @if (data.appName) {
<p class="app-name"><strong>Application:</strong> {{ data.appName }}</p>
}

        <!-- AI Assessment History visible only for Enterprise Lead -->
        @if (data.aiJobs && data.aiJobs.length > 0) {
<div class="ai-history-section">
            <div class="section-heading">AI Code Assessment History</div>
            <table class="ai-history-table">
                <thead>
                    <tr>
                        <th>Date</th>
                        <th>Status</th>
                        <th>Type</th>
                        <th>Branch</th>
                        <th>Requested By</th>
                        <th>Score</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    @for (job of data.aiJobs; track job) {
<tr>
                        <td>{{ job.createdAt | utcDate:'short' }}</td>
                        <td>
                            <span class="ai-status-badge"
                                [ngClass]="{
                                    'badge-completed': isJobCompleted(job),
                                    'badge-failed': isJobFailed(job),
                                    'badge-running': isJobRunning(job)
                                }">{{ getStatusLabel(job) }}</span>
                        </td>
                            <td>{{ getJobTypeLabel(job) }}</td>
                        <td>{{ job.branch || '—' }}</td>
                        <td class="requested-by">{{ job.requestedByEmail || '—' }}</td>
                        <td>{{ getJobScore(job) ?? '—' }}</td>
                        <td>
                            @if (!isLightweightJob(job) && (isJobCompleted(job) || isJobFailed(job))) {
<button class="btn-view-ai"
                                   
                                    (click)="selectAiJob(job)">View</button>
}
                        </td>
                    </tr>
}
                </tbody>
            </table>
        </div>
}

        @if (data.aiJobs && data.aiJobs.length > 0) {
<div class="section-divider"></div>
}

        <div class="section-heading assignment-history-heading">
            Assignment History
        </div>

        @if (isLoading) {
<div class="text-center">
            <app-spinner [isLoading]="isLoading" diameter="30"></app-spinner>
        </div>
}

        @if (error) {
<div class="alert alert-danger">
            {{ error }}
        </div>
}

        @if (!isLoading && !error && assignmentHistoryLoaded && applicationHistory.length === 0) {
<div class="no-data">
            No history found for this application.
        </div>
}

        @if (!isLoading && !error && applicationHistory.length > 0) {
<div class="assignment-history-section">
            <table class="assignment-history-table">
                <thead>
                    <tr>
                        <th style="width: 150px;">Date</th>
                        <th style="width: 180px;">Action Taken By</th>
                        <th style="width: 180px;">Assigned To</th>
                        <th style="width: 100px;">Action</th>
                        <th style="width: auto;">Reason</th>
                        
                    </tr>
                </thead>
                <tbody>
                    @for (item of applicationHistory; track item; let i = $index) {
<tr>
                        <td>{{ item.createdAt | utcDate:'short' }}</td>
                        <td>{{ item.createdBy || '—' }}</td>
                        <td>{{ item.assignedTo || '—' }}</td>
                        <td>{{ item.action == null ? item.outcome : item.action }}</td>
                        <td>{{ item.overrideReason || (item.rejectionDetail || (item.rejectionReason || '—')) }}</td>
                        
                    </tr>
}
                </tbody>
            </table>
        </div>
}
    </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button class="btn" (click)="onClose()">Close</button>
</mat-dialog-actions>